import { AttachmentModel } from '@fc-vehicles/service/attachment-model';
import { VehicleManufacture } from '@fc-vehicles/models/vehicle.manufacture';
import {
  Hardware,
  Harness,
  StatusSet,
  VehicleStateType,
  VehicleType,
} from '@fc-core/models';
import { VehicleDriverStatus } from './vehicle-driver.model';
import { VehiclePowerSource } from '@fc-core/models/vehicle/power-source';

export enum VehicleStatus {
  active = 'active',
  waiting_for_data = 'pending',
}

export interface Vehicle {
  id: number;
  visibility?: string | number;
  status?: VehicleStatus;
  identifier: string;
  model: string;
  year: number;
  vin?: string;
  ifta: boolean;
  photo?: AttachmentModel;
  hardware: number | null;
  harness: number | null;
  groups: number[];
  created: string;
  type: number;
  statesUrl?: string;
  startingOdometer?: number;
  startingEngineHours?: number;
  powerSource?: VehiclePowerSource;
  specifications: { [key: string]: any };
  manufacturer: VehicleManufacture;
  camera?: number;
  hardwareObj?: Hardware;
  harnessObj?: Harness;
  typeObj?: VehicleType;
  pendingMaintenanceCount?: number;
  pendingDtcCount?: number;
  lastState?: LastVehicleState;
  lastReading?: LastVehicleReading;
  mil?: number;
  operators?: VehicleOperator[];
  loadingFields?: boolean;
  nonTracker?: boolean;
  currentLocation?: {
    id: number;
    name: string;
    type: number;
  };
  installType?: boolean;
  hash?: string;
  active?: boolean;
  operatorName?: string;
  setstatus?: StatusSet;
  ngcamera?: number;
  voltage?: number;
  operator?: VehicleDriverStatus;
  hasQrCode?: boolean;
}

export interface VehicleOperator {
  id: number;
  isArchived: boolean;
  isDisabled: boolean;
  employee: {
    id: string;
    firstName: string;
    lastName: string;
    avatar: string | AttachmentModel;
    user: {
      id: string;
      email: string;
    };
    color?: string;
  };
}

export interface LastVehicleState {
  duration: { lower: string; upper: string };
  type: VehicleStateType;
}

export interface LastVehicleReading {
  datetime: Date;
  heading: number;
  point: { lat: number; lng: number };
  signalStrength: number;
  batteryPercent?: number | null;
  speed: string;
}
